/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_street = /** @type {(inputs: {}) => string} */ () => {
	return `Ulice`
};

const da_street = /** @type {(inputs: {}) => string} */ () => {
	return `Gade`
};

const de_street = /** @type {(inputs: {}) => string} */ () => {
	return `Straße`
};

const en_street = /** @type {(inputs: {}) => string} */ () => {
	return `Street`
};

const es_street = /** @type {(inputs: {}) => string} */ () => {
	return `Calle`
};

const fr_street = /** @type {(inputs: {}) => string} */ () => {
	return `Rue`
};

const hu_street = /** @type {(inputs: {}) => string} */ () => {
	return `Utca`
};

const it_street = /** @type {(inputs: {}) => string} */ () => {
	return `Via`
};

const nl_street = /** @type {(inputs: {}) => string} */ () => {
	return `Straat`
};

const pl_street = /** @type {(inputs: {}) => string} */ () => {
	return `Ulica`
};

const pt_street = /** @type {(inputs: {}) => string} */ () => {
	return `Rua`
};

const sv_street = /** @type {(inputs: {}) => string} */ () => {
	return `Gata`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const street = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.street(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("street", locale)
	if (locale === "cs") return cs_street(inputs)
	if (locale === "da") return da_street(inputs)
	if (locale === "de") return de_street(inputs)
	if (locale === "en") return en_street(inputs)
	if (locale === "es") return es_street(inputs)
	if (locale === "fr") return fr_street(inputs)
	if (locale === "hu") return hu_street(inputs)
	if (locale === "it") return it_street(inputs)
	if (locale === "nl") return nl_street(inputs)
	if (locale === "pl") return pl_street(inputs)
	if (locale === "pt") return pt_street(inputs)
	return sv_street(inputs)
};